// extracted by mini-css-extract-plugin
module.exports = {"NavigationItems":"_3tGJ9kyU3HdUjwJ76R5TfX"};